import React from "react";
import useSortable from "./useSortable";
import SelectableGambit from "./SelectableGambit";
import { GambitTableProps, SortableGambitProps } from "../types";

const SortableGambit = ({
  order,
  actions,
  ...otherProps
}: SortableGambitProps) => {
  const { swapItems, ...otherActions } = actions;
  const { ref } = useSortable({ order, swapItems });
  return (
    <div ref={ref}>
      <SelectableGambit {...otherProps} actions={otherActions} />
    </div>
  );
};
export default function GambitTable({
  gambitData,
  editable,
  actions
}: GambitTableProps) {
  return (
    <div className="gambit-table">
      {gambitData.map((gambitEntry, order) => (
        <SortableGambit
          key={gambitEntry.id}
          editable={editable}
          actions={actions}
          gambit={gambitEntry}
          order={order}
        />
      ))}
    </div>
  );
}
